import { css } from 'styled-components'

export const mixin = {
  textEllipsis: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
}
